import BarCarousel from './BarCarousel';

export default BarCarousel;
